import { render } from "./AdmissionCommitteeView.vue?vue&type=template&id=18f75da5"
import script from "./AdmissionCommitteeView.vue?vue&type=script&lang=js"
export * from "./AdmissionCommitteeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__